import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './locales/de/translation.json';
import en from './locales/en/translation.json';
import es from './locales/es/translation.json';
import fr from './locales/fr/translation.json';
import id from './locales/id/translation.json';
import it from './locales/it/translation.json';
import ja from './locales/ja/translation.json';
import ms from './locales/ms/translation.json';
import nl from './locales/nl/translation.json';
import ptBR from './locales/pt-BR/translation.json';
import th from './locales/th/translation.json';
import zhCN from './locales/zh-CN/translation.json';

i18n.use(initReactI18next).init({
  resources: {
    de: { translation: de },
    en: { translation: en },
    es: { translation: es },
    fr: { translation: fr },
    id: { translation: id },
    it: { translation: it },
    ja: { translation: ja },
    ms: { translation: ms },
    nl: { translation: nl },
    'pt-BR': { translation: ptBR },
    th: { translation: th },
    'zh-CN': { translation: zhCN },
  },
  lng: 'ja',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
